import { nowIsoAndUnix } from "@@/shared/date-time/iso-and-unix";
import { luhnCheck } from "@@/utilities/luhn-check";
import type { Except } from "type-fest";
import { z } from "zod";
import type {
    _PayoutTargetBase} from "./_payout-target-base";
import {
    payoutTargetBaseZodSchema,
} from "./_payout-target-base";
import type {
    PayoutTargetId} from "./payout-target-id";
import {
    payoutTargetIdFactory,
    payoutTargetIdZodSchema,
} from "./payout-target-id";

type PayoutTargetPlusgiroType = "plusgiro";
const payoutTargetPlusgiroTypeZodSchema = z.literal("plusgiro");

type PayoutTargetPlusgiro = _PayoutTargetBase & {
    _id: PayoutTargetId;
    type: PayoutTargetPlusgiroType;
    plusgiro: string;
    customMessage?: string | null;
};

const plusGiroZodSchema = z
    .string()
    .min(2, "plusgironummer måste innehålla minst 2 siffror")
    .max(8, "plusgironummer får inte vara längre än 8 siffror")
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .refine(value => value.length && !isNaN(value as any), {
        message: "ogiltigt plusgironummer",
    })
    .refine(value => luhnCheck(value, true), {
        message: "ogiltigt plusgironummer",
    });

type Params = Except<
    PayoutTargetPlusgiro,
    "_id" | "type" | "_type" | "_createdAt"
>;
const plusGiroFactory = (params: Params): PayoutTargetPlusgiro => {
    return {
        ...params,
        _id: payoutTargetIdFactory(),
        _type: "PAYOUT_TARGET",
        _createdAt: nowIsoAndUnix(),
        type: "plusgiro",
    };
};

const payoutTargetPlusgiroZodSchema: z.ZodSchema<PayoutTargetPlusgiro> =
    z.intersection(
        payoutTargetBaseZodSchema,
        z.object({
            _id: payoutTargetIdZodSchema,
            type: payoutTargetPlusgiroTypeZodSchema,
            plusgiro: plusGiroZodSchema,
            customMessage: z.string().nullable(),
        }),
    );

export {
    payoutTargetPlusgiroTypeZodSchema,
    payoutTargetPlusgiroZodSchema,
    plusGiroFactory,
    plusGiroZodSchema,
};
export type { PayoutTargetPlusgiro, PayoutTargetPlusgiroType };
